module.exports = __webpack_public_path__ + "img/40_38_075_630.373d2f62.jpg";